export const UNSUBSCRIBE_API_PREFIX = '/api/mailing/subscription'

export const RESUBSCRIBE_API_PREFIX = '/api/mailing'
